var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "UIInput",
    _vm._g(
      _vm._b(
        { staticClass: "number-input", attrs: { value: _vm.formattedValue } },
        "UIInput",
        _vm.props,
        false
      ),
      _vm.listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }